/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Suggestions_LabelInputs */



/**
* | output |
* | --- |
* | "Suggested questions" |
*
* @param {Chat_Suggestions_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_suggestions_label = /** @type {((inputs?: Chat_Suggestions_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voorgestelde vragen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Questions suggérées")
	return /** @type {LocalizedString} */ ("Suggested questions")
});